import React, { useEffect } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { LoginStepValues } from "../../_interfaces/IAdminInvitationStepTypeValues";
import { IAdminInvitationFlowValues } from "../../_interfaces/IAdminInvitationFlowValues";
import { Container, createStyles, makeStyles, Paper, Theme } from "@material-ui/core";
import { LoginForm } from "../../../../authentication/components/LoginForm";
import { useLoginController } from "../../hooks/useLoginController";
import { observer } from "mobx-react";
import { AdminInvitationHeader } from "../AdminInvitationHeader";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            marginTop: theme.spacing(2),
            padding: theme.spacing(4),
            display: 'inline-block',
            position: 'relative' // the loading spinner refers to this element
        },
    })
);

export const LoginStep: React.FC<
    StepRenderProps<LoginStepValues, IAdminInvitationFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const classes = useStyles();
    const controller = useLoginController(values, allValues, update, submit);

    /********* Effects *********/

    useEffect(() => {
        update({
            password: "",
        });
    }, [])

    /********* Render *********/

    return (
        <Container>
            <Paper className={classes.content}>
                <AdminInvitationHeader organizationName={allValues.organizationName || ""} />
                <LoginForm
                    values={controller.values}
                    onChange={(patch) => {
                        controller.onChange(patch);
                        update(patch);
                    }}
                    onSubmit={controller.onSubmit}
                    isSubmitting={controller.isSubmitting}
                    error={controller.error}
                    fieldErrors={controller.fieldErrors}
                />
            </Paper>
        </Container>
    );
});
